import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Base64 } from '@shared/utils/classes/base64';
import dayjs from 'dayjs';
import { HttpResponseAlt } from '@shared/utils/models/http.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AffiliateActions } from '../actions/affiliate.actions';
import { AffiliateProfile } from '@core/utils/models/affiliate.model';
import { SsrCookieService } from '@shared/utils/services/ssr-cookie-service.service';

@Injectable()
export class AffiliateService extends HttpHandler {
  private readonly store = inject(Store);
  private readonly cookieService = inject(SsrCookieService);

  private readonly affiliateCookieName = `1348cb53-c1c3-4aa6-85b0-407ea54cf13a`;

  init(): void {
    const hash: string | null = this.getAffiliateHashFromCookie();
    hash && this.store.dispatch(AffiliateActions.setHash({ hash }));
  }

  getAffiliateHashFromCookie(): string | null {
    const hashB64: string | undefined = this.cookieService.get(this.affiliateCookieName);
    return hashB64 ? Base64.decodeUnicode(hashB64) : null;
  }

  saveAffiliateHashToCookie(hash: string): void {
    this.cookieService.set(this.affiliateCookieName, Base64.encodeUnicode(hash), dayjs().add(1, 'day').toDate(), '/');
  }

  getAffiliateProfile(hash: string): Observable<HttpResponseAlt<[AffiliateProfile]>> {
    const url: string = environment.apiUrls.affiliates.getProfile;
    return this.post<HttpResponseAlt<[AffiliateProfile]>>(url, { hash });
  }

  recordAffiliateAction(hash: string, actionId: number): Observable<HttpResponseAlt<number>> {
    const url: string = environment.apiUrls.affiliates.recordAction;
    const params = {
      hash,
      action_id: actionId,
    };
    return this.post<HttpResponseAlt<number>>(url, params);
  }
}
